import {
  DashboardContainer, DashboardContainerBody, DashboardContainerHeader, PublishedCountRow
} from '../MoaDashboard.styles';
import React, { Dispatch, SetStateAction } from 'react';
import { Dayjs } from 'dayjs';
import EventCount from "../EventCount";
import { DashboardFilter } from "../../../services/dashboard/dashboard.types";
import DashboardFilterSelect from "../DashboardFilterSelect";

interface PublishedContainerProps {
  filter: DashboardFilter
  setFrom: Dispatch<SetStateAction<Dayjs | undefined>>
  setUntil: Dispatch<SetStateAction<Dayjs | undefined>>
  events: number
  isLoading: boolean
}

const PublishedContainer: React.FC<PublishedContainerProps> = (
    {
      filter,
      setFrom,
      setUntil,
      events,
      isLoading
    }
) => {
  return (
      <DashboardContainer data-testid="publishedContainer">
        <DashboardContainerHeader>Published</DashboardContainerHeader>
        <DashboardContainerBody>
          <PublishedCountRow>
            <DashboardFilterSelect
                filter={filter}
                setFrom={setFrom}
                setUntil={setUntil}
            />
            <EventCount
                label={'Events'}
                count={events}
                isLoading={isLoading}
            />
          </PublishedCountRow>
        </DashboardContainerBody>
      </DashboardContainer>
  );
};

export default PublishedContainer;